import React from 'react';
import PropTypes from 'prop-types';

import { GlossaryLink } from './glossary-link';

const IPropTypes = {
  className: PropTypes.string,
  entry: PropTypes.shape({
    entries: PropTypes.array.isRequired,
  }).isRequired,
};

const defaultProps = {
  className: '',
};

const GlossaryEntry = props => (
  props.entry.entries.map(entry => (
    <GlossaryLink
      className={props.className}
      entry={entry}
      key={entry.index}
    />
  ))
);

GlossaryEntry.propTypes = IPropTypes;
GlossaryEntry.defaultProps = defaultProps;

export { GlossaryEntry };



// WEBPACK FOOTER //
// ./src/common/glossary-entry/GlossaryEntry.jsx